import { Outlet, useParams } from 'react-router-dom';
import { UnitProvider } from '@/contexts/UnitContext';

/**
 * Wraps all /u/:unitId routes with UnitProvider so every child route
 * (shell pages, setup wizard, banking, etc.) can call useUnitContext.
 */
export default function UnitRouteLayout() {
  const { unitId } = useParams<{ unitId: string }>();
  return (
    <UnitProvider unitIdFromRoute={unitId ?? null}>
      <Outlet />
    </UnitProvider>
  );
}
